import { Directive, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
    /* tslint:disable-next-line:directive-selector */
    selector: '[keypressDirective]'
})
export class KeypressDirective implements OnInit, OnDestroy {
    @Output()
    public onKeyPressed: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();

    private subject: Subject<KeyboardEvent> = new Subject<KeyboardEvent>();
    private subscriptions: Subscription[] = [];

    public ngOnInit(): void {
        this.subscriptions.push(
            this.subject.pipe(
                debounceTime(200)
            ).subscribe((event) => {
                this.onKeyPressed.emit(event);
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    @HostListener('document:keypress', ['$event'])
    public handleKeyboardEvent(event: KeyboardEvent) {
        this.subject.next(event);
    }
}
